import { ProductDoc } from '@gooduncles/gu-app-schema';
import { GaEventType } from 'src/schema/schema-ga-event';
import { getAlgoliaIndex } from 'src/utils/algoliasearch-util';
import { facetFilters } from 'src/utils/constants/service-constants';
import { sendGaEvent } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const index = getAlgoliaIndex();

const fetcher = async (args: [string, number, string | undefined]) => {
  const [query, hitsPerPage] = args;
  const result = await index.search<ProductDoc>(query, {
    hitsPerPage,
    facetFilters,
  });
  sendGaEvent({
    name: GaEventType.SEARCH_INPUT,
    eventParams: {
      query,
      hits: result.nbHits,
    },
  });
  return result;
};

/**
 *
 * @param query
 * @param hitsPerPage
 * @param active 검색창을 활성화 한 경우에만 api를 호출한다.
 * @returns
 */
const useAlgoliaSearch = (query: string, hitsPerPage: number, active: boolean, userId?: string) => {
  const { data, isLoading, error } = useSWR(active && query.length > 0 ? [query, hitsPerPage, userId] : null, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    errorRetryCount: 2,
  });

  return {
    hits: data?.hits,
    total: data?.nbHits,
    loading: isLoading,
    error,
  };
};

export default useAlgoliaSearch;
